import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TextField, Button, Stack, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2'
import api from "../../Services/api";
import {LoginCredentialsType} from '../../Utils/types'

const { postLogin } = api.create();

export const SelfServiceLogin = () => {
    const { t } = useTranslation()

    const [formData, setFormData] = useState({
        systemName: "",
        systemKey: ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const response = await postLogin(
            formData.systemName,
            formData.systemKey
        )
        if (response.ok) {
            const data = response.data as LoginCredentialsType;
            console.log("Response Data:", data);
            localStorage.setItem('apiKey', data.apiKey);
            localStorage.setItem('systemName', data.systemName);
            localStorage.setItem('chainId', data.chainId);
            localStorage.setItem('stationId', data.stationId);
        } else {
            console.error("Error fetching data:", response);
        }
        window.location.reload();
    };

    return (<form onSubmit={handleSubmit}>
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className={'pageMainContainer'}>
            <Grid>
                <Typography color={"secondary"} variant="h4">Rekisteröi kassa</Typography>
            </Grid>
            <Grid style={{width: 350}}>
                <Stack direction="column" spacing={2}>
                    <div>
                        <Typography gutterBottom>System Name</Typography>
                        <TextField
                            id="username"
                            color="secondary"
                            fullWidth
                            placeholder="System Name"
                            name="systemName"
                            value={formData.systemName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div>
                        <Typography gutterBottom>System Key</Typography>
                        <TextField
                            id="password"
                            color="secondary"
                            fullWidth
                            placeholder="System Key"
                            name="systemKey"
                            value={formData.systemKey}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </Stack>
            </Grid>
            <Grid>
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ mt: 2 }}
                >
                    Rekisteröi
                </Button>
            </Grid>
        </Grid>
    </form>);
}
